import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { BlockVariantSide } from "@tKgpco/Components/Common/Block/variant/base";
import { variantsUsingVariantSide } from "@tKgpco/Components/Common/Block/variant/config";

export const blockVariantSideFieldOptions = [
    {
        displayName: "Top",
        value: BlockVariantSide.Top,
    },
    {
        displayName: "Bottom",
        value: BlockVariantSide.Bottom,
    },
];

const blockVariantSideField = {
    displayName: "Variant Side",
    tooltip: "Determines on which side to apply the variant styles (Default: Both Sides)",
    editorTemplate: "DropDownField",
    options: blockVariantSideFieldOptions,
    defaultValue: BlockVariantSide.Both,
    fieldType: "General",
    isVisible: (x: any) => variantsUsingVariantSide.includes(x?.fields?.blockVariant),
} as DropDownFieldDefinition<string>;

export default blockVariantSideField;
